// Ürün galerisi — Mandarin Stone davranışı.
//
// 1. Oklar (ana görseldeki ve şeridin iki yanındaki) bir önceki / sonraki küçük
//    resme tıklar; uçlarda başa / sona döner. Geçişin kendisini Dawn'ın
//    media-gallery.js'i yapıyor (aktif görsel, küçük resim vurgusu, mobilde
//    kaydırma); burada sadece sıradaki küçük resim bulunuyor.
// 2. Şerit, seçili küçük resmi soldan ikinci sırada tutacak şekilde yumuşakça
//    kayar — görsel hangi yoldan değişirse değişsin (ok, küçük resim, parmakla
//    kaydırma, varyant değişimi).
// 3. Masaüstünde eski görsel 0,5 sn'de solarak kaybolur (CSS: .custom-gallery-leaving).
//
// Tıklamalar olay delegasyonuyla dinleniyor, gözlemciler <custom-gallery-effects>
// elemanına bağlı: Dawn galeri listesini yeniden dizdiğinde de, bölüm yeniden
// basıldığında da kendiliğinden yeniden kuruluyorlar.

// hide_variants açıkken varyanta bağlı görsellerin küçük resmi display:none — sıraya girmesin.
// const değil function: script sayfada iki kez çalışırsa (Dawn'ın quick-add'i
// script'leri yeniden çalıştırıyor) const yeniden tanımlama hatası verirdi.
function customGalleryThumbs(thumbnails) {
  return Array.from(thumbnails.querySelectorAll('[data-target]')).filter(
    (item) => getComputedStyle(item).display !== 'none'
  );
}

if (!window.customGalleryArrows) {
  window.customGalleryArrows = true;

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-custom-gallery-step]');
    if (!arrow) return;

    const gallery = arrow.closest('media-gallery');
    const thumbnails = gallery?.querySelector('[id^="GalleryThumbnails"]');
    if (!thumbnails) return;

    const items = customGalleryThumbs(thumbnails);
    if (items.length < 2) return;

    let current = -1;

    // Arka arkaya hızlı basışta: Dawn kaydırmayı setTimeout ile başlatıyor,
    // ikinci basışta liste henüz yerinden oynamamış olabiliyor. Son hedefi
    // kısa süre hatırla.
    const recent = gallery.customGalleryLast;
    if (recent && Date.now() - recent.time < 1000) {
      current = items.findIndex((item) => item.dataset.target === recent.target);
    }

    // Mobilde görsel parmakla da kaydırılıyor ve Dawn küçük resim vurgusunu
    // 500ms gecikmeyle güncelliyor — kaydırır kaydırmaz oka basılırsa eski
    // görselden sayardık. Liste kayabiliyorsa ekrandaki slayt esas.
    const list = gallery.querySelector('[id^="Slider-Gallery"]');
    if (current < 0 && list && list.scrollWidth - list.clientWidth > 1) {
      const slides = Array.from(list.children).filter((slide) => slide.dataset.mediaId);
      const visible = slides[Math.round(list.scrollLeft / list.clientWidth)];
      current = items.findIndex((item) => item.dataset.target === visible?.dataset.mediaId);
    }

    if (current < 0) {
      current = Math.max(
        0,
        items.findIndex((item) => item.querySelector('[aria-current]'))
      );
    }

    const step = Number(arrow.dataset.customGalleryStep);
    const next = (current + step + items.length) % items.length;

    const target = items[next].dataset.target;
    gallery.customGalleryLast = { target, time: Date.now() };

    // Bekleyen slideChanged'in slaytını yeni hedefe çevir (aşağıdaki dinleyiciye bak)
    const pending = gallery.querySelector('[id^="GalleryViewer"]')?.customLastSlideEvent;
    const targetSlide = list && Array.from(list.children).find((slide) => slide.dataset.mediaId === target);
    if (pending && targetSlide) pending.detail.currentElement = targetSlide;

    items[next].querySelector('button')?.click();
  });

  // Mobilde Dawn küçük resim vurgusunu, kaydırma bittikten 500ms sonra son
  // slideChanged olayının slaytına göre ayarlıyor. Oka yarım saniye arayla
  // basılınca bir önceki basışın olayı yeni basıştan sonra gelip vurguyu yarım
  // saniyeliğine bir adım geri alıyordu. Son olayı tutuyoruz ki okla hedef
  // değişince onun slaytını güncelleyebilelim. slideChanged kabarcıklanmıyor,
  // o yüzden yakalama aşamasında dinleniyor.
  document.addEventListener(
    'slideChanged',
    (event) => {
      if (event.target.id?.startsWith('GalleryViewer')) event.target.customLastSlideEvent = event;
    },
    true
  );
}

if (!customElements.get('custom-gallery-effects')) {
  customElements.define(
    'custom-gallery-effects',
    class CustomGalleryEffects extends HTMLElement {
      connectedCallback() {
        const gallery = this.closest('media-gallery');
        this.thumbnails = gallery?.querySelector('[id^="GalleryThumbnails"]');
        this.viewerList = gallery?.querySelector('[id^="Slider-Gallery"]');
        if (!this.thumbnails || !this.viewerList) return;

        // Dawn vurguyu önce hepsinden kaldırıp sonra birine koyuyor — tek seferde hizala
        this.stripObserver = new MutationObserver(() => this.alignStrip());
        this.stripObserver.observe(this.thumbnails, {
          subtree: true,
          attributes: true,
          attributeFilter: ['aria-current'],
        });

        this.fadeObserver = new MutationObserver((records) => records.forEach((record) => this.onMediaClass(record)));
        this.fadeObserver.observe(this.viewerList, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class'],
          attributeOldValue: true,
        });
      }

      disconnectedCallback() {
        this.stripObserver?.disconnect();
        this.fadeObserver?.disconnect();
      }

      // Mandarin gibi: seçili küçük resim soldan ikinci, solunda bir önceki
      // görünsün. Kaydırmayı Dawn'ın `scroll-behavior: smooth`'u yumuşatıyor.
      // Dawn da bu sırada kendi kaydırmasını başlatmış olabilir; gözlemci ondan
      // sonra çalıştığı için son söz bizde.
      alignStrip() {
        const list = this.thumbnails.querySelector('[id^="Slider-Thumbnails"]');
        const items = customGalleryThumbs(this.thumbnails);
        const index = items.findIndex((item) => item.querySelector('[aria-current]'));
        if (!list || index < 0) return;

        list.scrollTo({ left: index > 0 ? items[index - 1].offsetLeft : 0 });
      }

      // Masaüstünde (liste kaymıyorken) is-active'i kaybeden görsel, üstte
      // kalıp solarak kaybolur; altındaki yeni görsel açılır.
      onMediaClass(record) {
        const item = record.target;
        if (!item.classList.contains('product__media-item')) return;

        if (item.classList.contains('is-active')) {
          this.stopFade(item);
          return;
        }

        const wasActive = /(^|\s)is-active(\s|$)/.test(record.oldValue || '');
        const isSlider = this.viewerList.scrollWidth - this.viewerList.clientWidth > 1;
        if (!wasActive || isSlider || item.classList.contains('custom-gallery-leaving')) return;

        item.classList.add('custom-gallery-leaving');
        const done = () => this.stopFade(item);
        item.addEventListener('animationend', done, { once: true });
        item.customFadeTimer = setTimeout(done, 700);
      }

      // contains kontrolü şart: classList.remove sınıf yokken de class
      // özniteliğini yeniden yazıyor, gözlemci bunu değişiklik sayıp tekrar
      // çağırıyor — aktif görselde sonsuz döngüye girip sayfayı kilitliyordu.
      stopFade(item) {
        clearTimeout(item.customFadeTimer);
        if (item.classList.contains('custom-gallery-leaving')) item.classList.remove('custom-gallery-leaving');
      }
    }
  );
}
